import shortid from 'shortid';
import * as ScriptRequestLogActions from '../actions/log.actions';

const initialState = {
  submitting: false,
  error: null,
  message: '',
  filter: {
    patientGroupIds: [],
    patientIds: [],
    drugName: null,
    fromDate: null,
    toDate: null,
  },
};

const logReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // SCRIPT_REQUEST_LOG_CHANGE_FILTER
    case ScriptRequestLogActions.SCRIPT_REQUEST_LOG_CHANGE_FILTER:
      return {
        ...state,
        filter: { ...state.filter, ...payload },
      };
    case ScriptRequestLogActions.SCRIPT_REQUEST_LOG_CLEAR_FILTER:
      return {
        ...state,
        filter: { ...initialState.filter },
      };
    // SCRIPT_REQUEST_LOG_RESET
    case ScriptRequestLogActions.SCRIPT_REQUEST_LOG_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default logReducer;
